import { ReactElement } from "react";

import {
  FloatingEntityList,
  FloatingLogs,
  FloatingNodeSelector,
  FloatingSearch,
  FloatingSettings,
  FloatingStickyNote,
  FloatingZoomControls,
} from "./floating";

export const FloatingGraphTools = (): ReactElement => {
  return (
    <div className="fixed left-4 top-1/2 z-50 -translate-y-1/2">
      <div className="ring-.75 flex flex-col items-center gap-5 rounded-full bg-zinc-900/90 p-2 shadow-lg ring-zinc-600">
        <FloatingEntityList />
        <FloatingStickyNote />
        <FloatingSearch />
        <FloatingNodeSelector />
        <FloatingZoomControls />
        <FloatingLogs />
        <FloatingSettings />
      </div>
    </div>
  );
};
